import { Controller } from '@hotwired/stimulus';

/**
 * レイアウトコントローラー
 * サイドバーの表示・非表示を切り替える
 */
export default class extends Controller {
  static override targets = ['sidebar', 'sidebarTitle', 'sidebarLinkText'];

  declare readonly sidebarTarget: HTMLElement;
  declare readonly sidebarTitleTarget: HTMLElement;
  declare readonly sidebarLinkTextTargets: HTMLElement[];

  declare sidebarCollapsedWidth: string;
  declare isCollapsed: boolean;

  override connect() {
    // 初期状態を設定
    this.isCollapsed = false;
    this.sidebarCollapsedWidth = 'w-[80px]';
    this.updateLayout(this.isCollapsed);
  }

  /**
   * サイドバーの表示・非表示を切り替えるメソッド
   */
  toggle() {
    if (!this.sidebarTarget) {
      console.error('sidebar target not found');
      return;
    }

    this.isCollapsed = !this.isCollapsed;
    this.updateLayout(this.isCollapsed);
  }

  /**
   * レイアウトの状態を更新するメソッド
   */
  private updateLayout(isCollapsed: boolean) {
    if (!this.sidebarTarget) return;

    if (isCollapsed) {
      // サイドバーを閉じる
      this.sidebarTarget.classList.add(this.sidebarCollapsedWidth);

      // タイトルを非表示にする
      this.sidebarTitleTarget.classList.add('hidden');

      // リンクテキストを非表示にする
      this.sidebarLinkTextTargets.forEach(target => {
        target.classList.add('hidden');
      });
    } else {
      // サイドバーを開く
      this.sidebarTarget.classList.remove(this.sidebarCollapsedWidth);

      setTimeout(() => {
        // タイトルを表示にする
        this.sidebarTitleTarget.classList.remove('hidden');

        // リンクテキストを表示にする
        this.sidebarLinkTextTargets.forEach(target => {
          target.classList.remove('hidden');
        });
      }, 300);
    }
  }
}
